<template>
  <div id="installment">
    <div class="head">
      <img src="@/assets/image/TradeTip/installmentHead.png" alt="" @click="goToCus('https://tb.53kf.com/code/client/528d4f3bc25d9279010007a8c01daf5a4/1')">
    </div>
    <div class="text">
      <img src="@/assets/image/TradeTip/installmentText.png" alt="">
    </div>
    <div class="installment" >
      <div class="installment_title">
        <img src="@/assets/image/PersonalCenter/MyAccount/contentItemTitle.png" alt="">
        分期购计算器
      </div>
      <div class="installment_inputG">
        <div id="amount">
          金额：
          <el-input v-model="amount" placeholder="请输入" :maxlength="6" @input="amountChange"></el-input>
        </div>
        <div id="downPay">
          首付：
          <el-select v-model="downPay" :popper-append-to-body="false" placeholder="请选择" @change="downPayChange">
            <el-option
              v-for="(item,index) in downPaySelect"
              :key="index"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div id="staging">
          期数：
          <el-select v-model="staging" :popper-append-to-body="false" placeholder="请选择" @change="stagingChange">
            <el-option
              v-for="(item,index) in stagingSelect"
              :key="index"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="installment_content">
        <div class="installment_content_left contentItem">
          <div>首付款：{{ downPayMoney }}</div>
          <div>总还款：{{ totalMoney }}</div>
        </div>
        <div class="installment_content_right contentItem">
          <div class="monthlyPayment_title">月付款：</div>
          <div class="monthlyPayment">
            <div v-for="(item,index) in monthlyPayment" :key="index">{{ item }}</div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>
<script>

export default {
  name: '',
  props: {
  },
  components: {

  },
  data () {
    return {
      pageInfo:'',
      // 分期购 金额
      amount:'',
      // 分期购 首付下拉框
      downPaySelect: [
        {value: 3, label: '首付三成'},
        {value: 4, label: '首付四成'},
        {value: 5, label: '首付五成'},
        {value: 6, label: '首付六成'},
      ],
      // 分期购 首付
      downPay: 3,
      // 分期购 期数下拉框
      stagingSelect:[
        {value: 1, label: '一期'},
        {value: 2, label: '二期'},
        {value: 3, label: '三期'},
      ],
      // 分期购 期数
      staging: 1,
      // 分期购 首付款
      downPayMoney:'',
      // 分期购 首付款
      totalMoney:'',
      // 分期购 月付款
      monthlyPayment:[],
      // 分期购 尾款
      finalMoney:0,
      // 分期购 本息
      principalAndInterest:0
    }
  },
  methods: {
    goToCus(url) {
      window.open(url)
    },
    amountChange(){
      this.monthlyPaymentCom()
      if (!this.amount) {
        this.downPayMoney = ''
        this.totalMoney = ''
        this.monthlyPayment = []
      }
    },
    downPayChange(){
      this.amountChange()
    },
    stagingChange(){
      this.amountChange()
    },
    monthlyPaymentCom(){
      this.downPayMoney = parseFloat(this.amount * (this.downPay / 10)).toFixed(0)
      this.finalMoney = this.amount - this.downPayMoney
      this.monthlyPayment = []
      this.principalAndInterest = 0
      this.totalMoney = 0
      //每月月供
      let total = 0
      //每月本金
      let money = 0
      //每月利息
      let interest = 0
      //每月本金 = 尾款 / 期数
      money = parseFloat((this.finalMoney)/this.staging).toFixed(0)
      for (let i = 0; i < this.staging; i++) {
        // 利息 = 尾款 * 0.1
        if (this.finalMoney < 10000) {
          interest = parseFloat(this.finalMoney * 0.1).toFixed(0)
        }else {
          interest = parseFloat(this.finalMoney * 0.08).toFixed(0)
        }
        //剩余尾款 = 尾款 - 每月本金
        this.finalMoney = this.finalMoney*1 - money
        //每月月供 = 本金 + 利息
        total = money*1 + interest*1
        this.monthlyPayment.push(i+1 + '期: ￥'+total+' （ 本金￥'+ money +' + 折损费￥'+interest+' ）')
        //本利 = 每月月供总和
        this.principalAndInterest = this.principalAndInterest + total
      }
      //总还款 = 本息 + 首付款
      this.totalMoney = this.principalAndInterest*1 + this.downPayMoney*1
    }
  },
  mounted () {
  },
  watch: {

  },
  computed: {

  }
}
</script>

<style lang="less" scoped>
#installment{
  padding: 32px 40px 64px;
  color: var(--text-secondary, #5A5F6B);
  .head{
    margin: 0 0 28px;
    img{
      display: block;
      width: 100%;
      border-radius: 4px;
      cursor: pointer;
    }
  }
  .text{
    margin: 0 0 36px;
    padding: 24px;
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    background: var(--bg-section, #F7F5F2);

    img{
      display: block;
      max-width: 100%;
      height: auto;
      margin: 0 auto;
    }
  }
  .installment{
    padding: 28px 30px 32px;
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    background: var(--bg-card, #FFFFFF);
    box-shadow: 0 8px 20px rgba(26, 29, 36, 0.06);

    .installment_title{
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: var(--text-main, #111827);
      line-height: 28px;
      display: flex;
      align-items: center;
      flex-direction: row;
      position: relative;

      &::before{
        content: '';
        width: 5px;
        height: 18px;
        margin-right: 12px;
        background: var(--bg-dark, #1A1D24);
        transform: skewX(-12deg);
      }

      img{
        display: none;
      }
    }
    .installment_inputG{
      margin: 24px 0 18px 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 16px;

      div{
        flex: 1;
        font-size: 15px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
        line-height: 25px;
        white-space: nowrap;

        /deep/.el-input,
        /deep/.el-select{
          width: 193px;
        }

        /deep/.el-input__inner{
          height: 38px;
          border-radius: 4px;
          border-color: var(--border-soft, #E8E4DE);
          color: var(--text-main, #111827);
          background: var(--bg-card, #FFFFFF);
        }

        /deep/.el-input__inner:hover{
          border-color: var(--border-strong, #CBD5E1);
        }

        /deep/.el-input__inner:focus{
          border-color: var(--primary, #FF5A1F) !important;
          box-shadow: none;
        }
        /deep/.el-select-dropdown__item.hover{
          background-color: var(--bg-tag, #F0EDE8);
        }
        /deep/.el-select-dropdown__item.selected{
          color: var(--primary, #FF5A1F);
        }
        /deep/.el-input.is-focus .el-input__inner{
          border-color: var(--primary, #FF5A1F) !important;
        }
      }
      #amount{
        display: flex;
        flex-direction: row;
        align-items: center;
        /deep/.el-input__inner{
          width: 193px !important;
          font-size: 14px;
          line-height: 14px;
        }
      }
    }
    .installment_content{
      width: 100%;
      min-height: 94px;
      border-radius: 4px;
      border: 1px solid var(--border-soft, #E8E4DE);
      background: var(--bg-section, #F7F5F2);
      display: flex;
      flex-direction: row;
      padding: 20px 24px;
      box-sizing: border-box;

      .contentItem{
        font-size: 15px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
        line-height: 26px;
      }
      .installment_content_left{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 32%;
        padding-right: 24px;
        border-right: 1px solid var(--border-soft, #E8E4DE);

        div{
          width: 100%;
          height: 25px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
      }
      .installment_content_right{
        width: 68%;
        display: flex;
        flex-direction: row;
        padding-left: 24px;

        .monthlyPayment_title{
          width: 72px;
          color: var(--text-main, #111827);
          font-weight: 500;
        }
        .monthlyPayment{
          width: calc(~"100% -  72px");
          div{
            width: 100%;
            height: 25px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }

        }
      }
    }
  }
}

</style>
